const videos = {
  gweBackstory: {
    title: "The Story Of The Global Warming Express",
    contentId: "gweBackstory",
    description: "Learn the history of The Global Warming Express.",
    runTime: "1 min 6 sec",
    featImg: `${process.env.PUBLIC_URL}/assets/videos/thumbnails/gweBackstory.png`,
    src: "https://www.youtube.com/embed/kwP-su2F9Cc",
  },
};
export default videos;
